import { Routes } from '@angular/router';
import { adminAuthGuard } from '../core/guards/admin-auth.guard';
import { adminPortalRedirectGuard } from '../core/guards/admin-portal-redirect.guard';
import { adminPermissionGuard } from '../core/guards/admin-permission.guard';
import { AdminLayoutComponent } from '../layout/admin-layout/admin-layout.component';

export const adminRoutes: Routes = [
  {
    path: 'admin-login',
    canActivate: [adminPortalRedirectGuard],
    loadComponent: () =>
      import('../pages/admin/auth/login/login.component').then((m) => m.AdminLoginComponent),
  },
  {
    path: 'admin/setup-password',
    canActivate: [adminPortalRedirectGuard],
    loadComponent: () =>
      import('../pages/admin/auth/setup-password/setup-password.component').then(
        (m) => m.StaffSetupPasswordComponent,
      ),
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [adminAuthGuard],
    canActivateChild: [adminPermissionGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('../pages/admin/dashboard/dashboard.component').then((m) => m.AdminDashboardComponent),
        data: { permission: 'Dashboard - Can view in sidebar' },
      },
      {
        path: 'bookings',
        loadComponent: () =>
          import('../pages/admin/booking-management/booking-management.component').then(
            (m) => m.AdminBookingManagementComponent,
          ),
        data: { permission: 'Bookings - Can view in sidebar' },
      },
      {
        path: 'bookings/:id',
        loadComponent: () =>
          import('../pages/admin/booking-management/detail/booking-detail.component').then(
            (m) => m.AdminBookingDetailComponent,
          ),
        data: { permission: 'Bookings - Can view in sidebar' },
      },
      {
        path: 'calendar',
        loadComponent: () =>
          import('../pages/admin/calendar-management/calendar-management.component').then(
            (m) => m.AdminCalendarManagementComponent,
          ),
        data: { permission: 'Calendar - Can view in sidebar' },
      },
      {
        path: 'room-types',
        loadComponent: () =>
          import('../pages/admin/room-type-management/room-types.component').then((m) => m.AdminRoomTypesComponent),
        data: { permission: 'Room types - Can view in sidebar' },
      },
      {
        path: 'room-types/:id/edit',
        loadComponent: () =>
          import('../pages/admin/room-type-management/edit/edit.component').then((m) => m.RoomTypeEditComponent),
        data: { permission: 'Room types - Can view in sidebar' },
      },
      {
        path: 'pricing',
        loadComponent: () =>
          import('../pages/admin/pricing-management/pricing-management.component').then(
            (m) => m.AdminPricingManagementComponent,
          ),
        data: { permission: 'Pricing - Can view in sidebar' },
      },
      {
        path: 'payments',
        loadComponent: () =>
          import('../pages/admin/payment-management/payment-management.component').then(
            (m) => m.AdminPaymentManagementComponent,
          ),
        data: { permission: 'Payments - Can view in sidebar' },
      },
      {
        path: 'guests',
        loadComponent: () =>
          import('../pages/admin/guest-management/guests.component').then((m) => m.AdminGuestsComponent),
        data: { permission: 'Guests - Can view in sidebar' },
      },
      {
        path: 'guests/:id',
        loadComponent: () =>
          import('../pages/admin/guest-management/detail/guest-detail.component').then(
            (m) => m.GuestDetailComponent,
          ),
        data: { permission: 'Guests - Can view in sidebar' },
      },
      {
        path: 'reviews',
        loadComponent: () =>
          import('../pages/admin/review-management/review-management.component').then(
            (m) => m.AdminReviewManagementComponent,
          ),
        data: { permission: 'Reviews - Can view in sidebar' },
      },
      {
        path: 'inquiries',
        loadComponent: () =>
          import('../pages/admin/inquiry-management/inquiry-management.component').then(
            (m) => m.AdminInquiryManagementComponent,
          ),
        data: { permission: 'Inquiries - Can view in sidebar' },
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('../pages/admin/notification-management/notification-management.component').then(
            (m) => m.AdminNotificationManagementComponent,
          ),
        data: { permission: 'Notifications - Can view in sidebar' },
      },
      {
        path: 'content',
        loadComponent: () =>
          import('../pages/admin/content-management/content-management.component').then(
            (m) => m.AdminContentManagementComponent,
          ),
        data: { permission: 'Content - Can view in sidebar' },
      },
      {
        path: 'promotions',
        loadComponent: () =>
          import('../pages/admin/promotion-management/promotion-management.component').then(
            (m) => m.AdminPromotionManagementComponent,
          ),
        data: { permission: 'Promotions - Can view in sidebar' },
      },
      {
        path: 'analytics',
        loadComponent: () =>
          import('../pages/admin/analytics/analytics.component').then((m) => m.AdminAnalyticsComponent),
        data: { permission: 'Analytics - Can view in sidebar' },
      },
      {
        path: 'booking-embed',
        loadComponent: () =>
          import('../pages/admin/booking-embed/booking-embed.component').then(
            (m) => m.AdminBookingEmbedComponent,
          ),
        data: { permission: 'Booking embed - Can view in sidebar' },
      },
      {
        path: 'users',
        loadComponent: () =>
          import('../pages/admin/user-management/users.component').then((m) => m.AdminUsersComponent),
      },
      {
        path: 'staff',
        loadComponent: () =>
          import('../pages/admin/staff-management/staff-management.component').then(
            (m) => m.AdminStaffManagementComponent,
          ),
        data: { permission: 'Staff - Can view in sidebar' },
      },
      {
        path: 'staff/:id',
        loadComponent: () =>
          import('../pages/admin/staff-management/detail/staff-detail.component').then(
            (m) => m.StaffDetailComponent,
          ),
        data: { permission: 'Staff - Can view in sidebar' },
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('../pages/admin/role-management/role-management.component').then(
            (m) => m.AdminRoleManagementComponent,
          ),
        data: { permission: 'Roles - Can view in sidebar' },
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('../pages/admin/setting/setting.component').then((m) => m.AdminSettingComponent),
        data: { permission: 'Settings - Can view in sidebar' },
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
];
